var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHostfullyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blue_logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3600px",
    height: "1440px",
    viewBox: "0 0 3600 1440",
    enableBackground: "new 0 0 3600 1440",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 144,
    y: 243.999,
    width: 3312,
    height: 952
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_2_",
    d: "M924,1046.107c-123.234,0-220.902-95.844-220.902-218.266c0-122.417,97.668-218.269,220.902-218.269 s220.902,95.852,220.902,218.269C1144.902,950.264,1047.234,1046.107,924,1046.107L924,1046.107z M924,916.545 c50.477,0,87.012-36.234,87.012-88.703S974.477,739.139,924,739.139s-87.012,36.234-87.012,88.703S873.523,916.545,924,916.545 L924,916.545z M1319.277,744.264c0,7.906,10.656,13.938,38.219,21.531c5.16,1.422,24.566,6.484,27.199,7.188 c11.664,3.125,20.996,5.859,30.047,8.875c67.391,22.563,103.867,59.172,103.867,126.344c0,88.281-72.367,137.906-174.715,137.906 c-85.516,0-147.863-33.344-179.777-99.094l0,0c-1.406-2.891-0.316-6.375,2.484-7.953l105.398-59.5 c2.965-1.672,6.727-0.625,8.398,2.344c0.188,0.313,0.34,0.656,0.461,1.016l0,0c9.891,28.672,30.684,43.266,63.035,43.266 c25.863,0,37.582-6.781,37.582-18.781c0-7.406-10.598-13.625-37.07-21.438c-5.805-1.703-30.043-8.422-27.703-7.766 c-12.137-3.406-21.539-6.266-30.734-9.406c-67.457-23.125-103.824-58.266-103.824-121.313c0-85.382,69.652-137.91,164.992-137.91 c69.695,0,129.043,31.523,163.32,88.992l0,0c1.723,2.887,0.777,6.629-2.109,8.352c-0.082,0.047-0.164,0.094-0.25,0.141 l-103.766,55.472c-2.996,1.609-6.723,0.484-8.34-2.5l0,0c-11.672-21.5-26.734-32.141-48.855-32.141 C1328.766,727.889,1319.277,734.061,1319.277,744.264L1319.277,744.264z M1745.391,620.827h67.461c4.422,0,8,3.582,8,8v111.953 c0,4.422-3.578,8-8,8h-67.461c-4.418,0-8,3.594-8,8v128.125c0,25.953,18.094,31.969,76.914,28.438l0,0 c3.406-0.203,6.336,2.391,6.539,5.797c0.008,0.125,0.008,0.25,0.008,0.375v109.188c0,3.156-2.398,5.813-5.547,6.125l0,0 c-155.148,15.703-211.805-27.438-211.805-149.922V756.779c0-4.406-3.582-8-8-8h-48.824c-4.418,0-8-3.578-8-8V628.827 c0-4.418,3.582-8,8-8h48.824c4.418,0,8-3.582,8-8.004v-60.805c0-3.539,2.328-6.66,5.719-7.668l117.891-35.074 c4.234-1.262,8.691,1.152,9.953,5.387c0.219,0.738,0.328,1.508,0.328,2.281v95.879 C1737.391,617.245,1740.973,620.827,1745.391,620.827L1745.391,620.827z M2114.859,448.87L2114.859,448.87 c3.258,0.195,5.805,2.891,5.805,6.156v115.613c0,3.414-2.766,6.18-6.18,6.18c-0.18,0-0.359-0.008-0.539-0.027l0,0 c-43.789-3.875-66.172,9.215-68.445,44.035h67.164c4.422,0,8,3.582,8,8v111.953c0,4.422-3.578,8-8,8h-59.359 c-4.414,0-8,3.594-8,8v278.078h-125.891c-4.422,0-8-3.578-8-8V756.779c0-4.406-3.578-8-8-8h-38.289c-4.422,0-8-3.578-8-8V628.827 c0-4.418,3.578-8,8-8h46.352C1913.828,503.772,1984.102,441.057,2114.859,448.87L2114.859,448.87z M2433.742,1007.42 c-25.141,24.672-63.656,38.688-109.703,38.688c-91.578,0-157.695-67-157.695-172.453V628.827c0-4.418,3.578-8,8-8h117.891 c4.414,0,8,3.582,8,8v227.14c0,43.109,25.305,67,64.32,67c43.93,0,69.188-25.797,69.188-76.641v-217.5c0-4.418,3.578-8,8-8 h117.891c4.422,0,8,3.582,8,8v398.031c0,4.422-3.578,8-8,8h-117.891c-4.422,0-8-3.578-8-8V1007.42L2433.742,1007.42z  M2642.852,435.999h117.891c4.422,0,8,3.582,8,8v582.859c0,4.422-3.578,8-8,8h-117.891c-4.414,0-8-3.578-8-8V443.999 C2634.852,439.581,2638.438,435.999,2642.852,435.999L2642.852,435.999z M2843.969,435.999h117.891c4.422,0,8,3.582,8,8v582.859 c0,4.422-3.578,8-8,8h-117.891c-4.422,0-8-3.578-8-8V443.999C2835.969,439.581,2839.547,435.999,2843.969,435.999 L2843.969,435.999z M3318.961,620.827h132.711c1.688,0,3.055,1.367,3.055,3.055c0,0.348-0.063,0.695-0.18,1.023l-140.008,393.812 c-45.641,128.516-119.156,182.703-237.063,176.859l0,0c-3.289-0.172-5.867-2.875-5.867-6.172v-112.391 c0-3.422,2.758-6.172,6.172-6.172l0,0c53.266,0,77.75-15.578,94.656-60.438l-159.211-378.476 c-1.719-4.074,0.195-8.766,4.266-10.477c0.984-0.414,2.039-0.625,3.109-0.625h129.648c3.359,0,6.359,2.098,7.516,5.25 l83.211,227.484l70.344-227.101C3312.359,623.108,3315.461,620.827,3318.961,620.827L3318.961,620.827z M519.664,757.654V556.006 c0-4.418,3.578-8,8-8c1.473,0,2.914,0.41,4.172,1.176l119.293,72.969c2.379,1.457,3.828,4.043,3.828,6.828v402.753 c0,4.422-3.582,8-8,8H527.664c-4.422,0-8-3.578-8-8V894.529c0-4.422-3.586-8-8-8H343.293c-4.418,0-8,3.578-8,8v137.203 c0,4.422-3.582,8-8,8H208c-4.418,0-8-3.578-8-8V628.979c0-2.785,1.449-5.371,3.824-6.828l119.293-72.969 c3.77-2.305,8.695-1.117,11,2.652c0.77,1.254,1.176,2.699,1.176,4.172v193.648c0,4.422,3.582,8,8,8H519.664L519.664,757.654z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_",
    clipPath: "url(#SVGID_3_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 395.999,
    clipPath: "url(#SVGID_4_)",
    fill: "#2D2AA5",
    width: 3334.727,
    height: 840
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 144,
    y: 243.999,
    width: 3312,
    height: 952
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_6_",
    points: "704,547.999 424,384.225 144,547.999 144,407.776 424,243.999 704,407.776 704,547.999  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_",
    clipPath: "url(#SVGID_7_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 203.999,
    clipPath: "url(#SVGID_8_)",
    fill: "#40CAA1",
    width: 640,
    height: 384
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 144,
    y: 243.999,
    width: 3312,
    height: 952
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_10_",
    points: "704,547.999 424,384.225 424,243.999 704,407.776 704,547.999  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_",
    clipPath: "url(#SVGID_11_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 203.999,
    clipPath: "url(#SVGID_12_)",
    fill: "#46B48C",
    width: 360,
    height: 384
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostfullyLogo);
export default __webpack_public_path__ + "static/media/hostfullyLogo.a3716eac757ff54bbb274025cff62b1c.svg";
export { ForwardRef as ReactComponent };